//import cx from 'clsx';
import React from 'react';
import CookieConsent, { Cookies } from "react-cookie-consent";
import "./index.css";

function CookieConsentBanner({  }) {
let cookieObj = {
  debug: false,
}
let cookieName = "cookieConfirmation";
let cookies = document.cookie.split(';');
if (cookies.indexOf(cookieName+"=false") > -1 && cookies.indexOf(cookieName+"=true") < 0) {
  cookieObj.debug = true;
}else if (cookies.indexOf(cookieName+"=true") > -1 && cookies.indexOf(cookieName+"=false") < 0) {
  cookieObj.debug = false;
}
  return (
    <CookieConsent
      buttonStyle={{ backgroundColor: "#2E8FDE", color: "white", padding:"10px 15px", borderRadius:"10px", fontSize: "18px", transition:"0.3s", fontFamily:"'Open Sans', Roboto, Arial, sans-serif" }}
      declineButtonStyle={{ backgroundColor: "#9E1E53", padding:"10px 15px", borderRadius:"10px", fontSize: "18px", transition:"0.3s", fontFamily:"'Open Sans', Roboto, Arial, sans-serif" }}
      style={{ background: "rgba(43, 55, 59, 0.93)", paddingTop: "1%", paddingBottom: "1%"}}
      cookieName={cookieName}
      buttonText="Accept Cookies"
      declineButtonText="Do not set cookies on my device."
      location="bottom"
      buttonWrapperClasses="cookie-button-wrapper"
      debug={cookieObj.debug}
      expires={365}
      enableDeclineButton
      flipButtons={true}
      declineButtonText="Decline"
      onDecline={() => {
        window.onbeforeunload = null;
        window.location.href = "https://den.foxdenedm.com";
      }}
      {...cookieObj}
    >
    <div style={{
      width:"50%",
      margin:"0 auto",
      textAlign:"center"
    }}>
      <span style={{ fontSize:"20px", fontWeight:"bold"}}>This website uses cookies to enhance the user experience.{" "}</span>
      <br/>
      <br/>
      <span style={{ fontSize: "15px" }}>
      We use cookies to store a unique token which is used to log you in again automatically if you re-visit our website on the same device. Learn more about our Privacy and Cookie Policy <a target="_blank" href='/privacy.html'>here</a>.
      </span>
      </div>
    </CookieConsent>
  );
}

export default CookieConsentBanner;
